exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wang-editor {\n  width: 100%;\n  background-color: #fff;\n}\n._wangEditor_btn_html {\n  color: #999;\n  text-decoration: none;\n  font-weight: 600;\n  width: 35px;\n  display: block;\n}\n._wangEditor_btn_html.active {\n  font-weight: 800;\n  color: #333;\n  text-decoration: underline;\n}\n._wangEditor_html_area {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border: 0;\n  color: #606266;\n  line-height: 22px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c1ee1140","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/wangEditor.vue
// module id = 1153
// module chunks = 7